var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1659.77 500",
    style: {
      enableBackground: "new 0 0 1659.77 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#181516;}\r\n\t.st2{opacity:0.05;fill:none;stroke:#231F20;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#5D7763;}\r\n\t.st5{fill:#181516;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M919.14,297.34l-46.66-130.49l-31.68,0c-0.12,0.18-0.17,0.24-0.29,0.42l61.99,166.16h34.08l60.9-166.16 c-0.12-0.18-0.17-0.24-0.29-0.42l-30.8,0l-46.66,130.49C919.43,297.34,919.43,297.34,919.14,297.34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1472.8,253.97l-51.02-31.45c-4.52-2.79-7.68-7.63-7.61-12.95c0.11-7.87,6.54-14.24,14.43-14.24l53.79,0 v-28.49l-52.5,0c-24.08,0-44.67,19.71-44.2,43.79c0.29,14.66,7.87,27.95,20.39,35.67l51.77,31.91c4.22,2.6,6.77,7.09,6.85,12.04 c0.14,8.08-7.04,14.69-15.12,14.69l-50.05,0l-16.98,28.02c0.12,0.21,0.15,0.26,0.26,0.47l66.16,0c24.08,0,44.66-19.7,44.2-43.77 C1492.9,274.98,1485.32,261.69,1472.8,253.97"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1271.49,304.94V166.85H1243v166.57l85.14,0l16.98-28.02c-0.12-0.21-0.15-0.26-0.26-0.47H1271.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M543.68,304.94l0-138.09l-28.49,0v166.57l85.14,0l16.98-28.02c-0.12-0.21-0.15-0.26-0.26-0.47L543.68,304.94z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "676.96,166.85 676.96,333.42 676.96,333.42 782.78,333.42 782.78,333.42 782.78,304.94 705.44,304.94  705.44,264.38 772.22,264.38 772.22,235.89 705.44,235.89 705.44,195.34 782.78,195.34 782.78,166.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1057.2,166.85 1057.2,333.42 1057.2,333.42 1163.02,333.42 1163.02,333.42 1163.02,304.94  1085.69,304.94 1085.69,264.38 1152.47,264.38 1152.47,235.89 1085.69,235.89 1085.69,195.34 1163.02,195.34 1163.02,166.85  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M241.93,144.32l-75.35,22.43v188.91c0.17,0.12,0.23,0.17,0.4,0.3l75.35-22.43V144.62 C242.16,144.49,242.09,144.44,241.93,144.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.14,268.33v87.32c0.17,0.12,0.23,0.17,0.4,0.3l75.35-22.43V246.2c-0.17-0.12-0.23-0.17-0.4-0.3 L265.14,268.33z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5215d2694f312dbd75481913dab97e85.svg";
export { ForwardRef as ReactComponent };